import { render } from "./PackageDocuments.vue?vue&type=template&id=f7a64fdc&scoped=true"
import script from "./PackageDocuments.vue?vue&type=script&lang=js"
export * from "./PackageDocuments.vue?vue&type=script&lang=js"

import "./PackageDocuments.vue?vue&type=style&index=0&id=f7a64fdc&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7a64fdc"]])

export default __exports__